import { all, call } from 'redux-saga/effects';
import { runProductInSetClickDetector } from './ga-product-in-set-click.set';
import { runViewInSetDetector } from './ga-view-in-set.set';

export function* runSetsGaDetectors() {
  yield all([call(runProductInSetClickDetector), call(runViewInSetDetector)]);
}
